import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="bg-black min-h-screen">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 py-16 text-gray-300">
        <h1 className="text-4xl font-bold text-white mb-8">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mb-12">Last Updated: May 2, 2026</p>

        <section className="space-y-12">
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">1. Information We Collect</h2>
            <p className="leading-relaxed">
              When you register for PlayConnect, we collect information such as your name, email address, location, and preferred sports. 
              We also collect data about the matches you create or join to improve our matchmaking algorithms.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">2. How We Use Your Data</h2>
            <ul className="list-disc pl-6 space-y-3">
              <li>To provide and maintain our Service.</li>
              <li>To notify you about changes to our Service.</li>
              <li>To allow you to participate in interactive features when you choose to do so.</li>
              <li>To provide customer support and gather analysis or valuable information so that we can improve our Service.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">3. Data Security</h2>
            <p className="leading-relaxed">
              The security of your data is important to us. We use industry-standard encryption and security middleware (Helmet, HPP, Rate Limiting) 
              to protect your personal information from unauthorized access.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">4. Third-Party Services</h2>
            <p className="leading-relaxed">
              We may use third-party services like Google OAuth for authentication. These services have their own privacy policies regarding how they handle your data.
            </p>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
